import { combineReducers } from "redux";

import destinationsReducer from "./destinations";
import cohortsReducer from "./cohorts";
import environmentsReducer from "./environments";
import eventDefsReducer from "./events";
import dashboardReducer from "./dashboard";

const freshpaintReducer = combineReducers({
  environments: environmentsReducer,
  destinations: destinationsReducer,
  cohorts: cohortsReducer,
  eventDefs: eventDefsReducer,
  dashboard: dashboardReducer,
});

export default freshpaintReducer;
